import React from 'react';
import { Link } from 'gatsby';

import Search from '../Search/Search';
import Logo from '../../assets/images/svg/paystack.svg';
import Hamburger from '../../assets/images/svg/hamburger.svg';
import Magnifier from '../../assets/images/svg/search.svg';

import './header.scss';

const Header =({isSearchActive, toggleNav, toggleSearch}) => {

	return (
		<div className="header">
			<div className="header__brand">
				<Link to="/" className="header__brand__link">
					<Logo />
					<span className="header__brand__text">docs</span>
				</Link>
			</div>
			<div className={`header__search ${isSearchActive ? "header__search--mobile" : ""}`}>
				<Search isSearchActive={isSearchActive} toggleSearch={toggleSearch} />
			</div>
			<div className="header__actions">
				<div>
					<Link to="/" className="header__link" activeClassName="header__link--active" partiallyActive={true}>Docs</Link>
					<Link to="/api" className="header__link" activeClassName="header__link--active">API</Link>
				</div>
				<div>
					<a className="button" href="https://dashboard.paystack.com/" target="_blank" rel="noopener noreferrer">
						Sign up
					</a>
				</div>
			</div>
			<div className="header__actions header__actions--secondary">
				<button className="action__button button--search" onClick={toggleSearch}>
					<Magnifier className="action__button__icon" />
					<span className="button__text button__text--right">
						Search
					</span>
				</button>
				<button className="action__button action__button--right-space" onClick={toggleNav}>
					<Hamburger className="action__button__icon" />
					<span className="button__text button__text--right">
						Menu
					</span>
				</button>
			</div>
		</div>
	);
}

export default Header;
